export default "__VITE_ASSET__BkpSJCcV__"